import useLocale from '~/hooks/useLocale'

import { hasShop } from '~/utils/locales'

export default function useShop(type?: string): boolean {
  const locale = useLocale()
  return hasShop(locale, type)
}
